import React, { useState, useMemo, useRef } from "react";
import { Dialog } from "../components";
import { SearchOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { InfiniteScrollList } from "./table";
import { searchInField } from "../modules/api/search";
import {
  userClientDb,
  uiLanguage,
} from "../modules/auth/selectors/userSelector";
import { useSelector } from "react-redux";
import * as modules from "../utils/modules";
import { useSearchDialogStyles } from "./css";
import { TextField } from "./index";
import { useForm } from "react-final-form";
import { IScannerFields } from "./form/ScannerForm";

export interface ISearchDialog {
  openDialog: boolean;
  field: string;
  onClose: () => void;
  onConfirm: (value: any) => void;
  onExited?: () => void;
  module: modules.moduleType;
  scannerFormFields?: IScannerFields[];
}

function SearchDialog(props: ISearchDialog) {
  const { openDialog, onClose, onExited, module, field, onConfirm } = props;
  const { t } = useTranslation();
  const clientDb = useSelector(userClientDb);
  const locale = useSelector(uiLanguage);
  const { classes } = useSearchDialogStyles();
  const [filter, setFilter] = useState("");
  const { getState } = useForm();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (value: string) => {
    onConfirm("" + value);
  };

  const fieldValues = props.scannerFormFields?.reduce(
    (acc: { [key: string]: any }, field: any) => {
      const fieldName = field.name;

      if (!fieldName) {
        return acc;
      }

      const fieldValue = getState().values?.[fieldName];
      acc[fieldName] = fieldValue !== undefined ? fieldValue : "";
      return acc;
    },
    {},
  );

  const loadDataparams = useMemo<{
    clientDbId: number;
    module: modules.moduleType;
    cellType: "header" | "info" | "item" | "search";
  }>(
    () => ({
      clientDbId: clientDb ? clientDb.id : 0,
      module: module,
      field: field,
      locale: locale,
      cellType: "search",
      onClick: handleChange,
      fil: filter,
      fieldValues: fieldValues,
      isList: 1,
    }),
    [module, field, locale, clientDb, filter],
  );

  const handleClose = () => {
    onClose();
  };

  const handleFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      maxWidth="xs"
      title={t("search")}
      isCancelButton
      greyHeader
      disableRestoreFocus
      onEntered={() => inputRef.current?.focus()}
      onExited={onExited}
    >
      <div className={classes.search}>
        <TextField
          onChange={handleFilter}
          startAdornment={<SearchOutlined fontSize="small" />}
          value={filter}
          autoFocus
          autoComplete="off"
          fillColor="white"
          ref={inputRef}
        />
      </div>

      <div className={classes.container}>
        <InfiniteScrollList
          loadData={searchInField}
          loadDataparams={loadDataparams}
          hideNoRowsLabel
          height={400}
        />
      </div>
    </Dialog>
  );
}

export default SearchDialog;
